module.exports = __webpack_public_path__ + "static/media/861BeutellStNW_2018-07-09_143.8c12f534.jpg";